module.exports = __webpack_public_path__ + "f2e8dcc9969f85f12a1237cb3219e3e7.png";